import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { loadResultsByStudent, clearResults } from '../../common/results/actions'
import { PageHeader, ResultsList } from '../components'

class StudentResultsPage extends React.Component {
  componentDidMount() {
    const { viewer, loadResultsByStudent } = this.props
    loadResultsByStudent(viewer.id)
  }

  componentWillUnmount() {
    if (this.userId) {
      this.props.clearResults()
    }
  }

  render() {
    const { results, intl } = this.props

    return (
      <div className="user-page">
        <PageHeader
          title={intl.formatMessage(messages.testResults)}
        />
        <ResultsList
          results={results}
          testAsTitle
        />
      </div>
    )
  }
}

StudentResultsPage.defaultProps = {
  results: [],
  viewer: null,
}

StudentResultsPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadResultsByStudent: PropTypes.func.isRequired,
  clearResults: PropTypes.func.isRequired,
  results: PropTypes.array,
  viewer: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    results: state.results.all,
  }), { loadResultsByStudent, clearResults }),
  injectIntl,
)

export default enhance(StudentResultsPage)

const messages = defineMessages({
  testResults: {
    id: 'studentResults.page.testResults',
    defaultMessage: 'Vaše výsledky testov',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/StudentResultsPage.js